<div class="ui-g-12 no-padding monaco-container"
	[ngClass]="{
		'disabled': disabled === true
	}">
	<ngx-monaco-editor
		[(ngModel)]="textDisplay"
		[options]="editorOptions"
		[style.height]="editorHeight"
		(ngModelChange)="editorChange($event)">
	</ngx-monaco-editor>
</div>

<div class="validation-message-container"
	*ngIf="!isValidText">
	<div class="validation-message ellipsis-text">
		Invalid JSON format.
	</div>
</div>